<template>
  <v-stepper :value="currentStep">
    <v-stepper-header>
      <template v-for="(step, index) in steps">
        <v-stepper-step
          @click.native="gotoStep(index + 1)"
          :class="{ click: index < currentStep }"
          :key="step"
          :step="index + 1"
          :complete="index + 1 < currentStep"
        >
          <span :class="{ 'secondary--text': index < currentStep }">
            {{
            step
            }}
          </span>
        </v-stepper-step>
        <v-divider :key="index" v-if="index < steps.length - 1"></v-divider>
      </template>
    </v-stepper-header>
    <v-divider class="divider"></v-divider>
  </v-stepper>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['steps', 'currentStep'],
  methods: {
    async gotoStep(step) {
      if (step < this.currentStep && step !== 1) {
        this.$store.dispatch('setCurrentStep', step);
      }
      if (step < this.currentStep && step === 1) {
        if (step === 1) {
          await this.$store.dispatch('setResetPurchase', true);
        }
      }
      if (step < this.currentStep && step === 3) {
        if (step === 3) {
          if (!this.signSteps.logged && this.signSteps.step === 5) {
            this.$store.dispatch('setSignSteps', { logged: false, signForm: true, step: 0 });
            this.$store.dispatch('setUserProps', { selectedDocument: 'cpf', emailConfirmation: null, email: null, document: null, name: null, phone: null });
          }
        }
      }
      if (step < this.currentStep && step === 2) {
        if (step === 2) {
          if (!this.signSteps.logged && this.signSteps.step === 5) {
            this.$store.dispatch('setSignSteps', { logged: false, signForm: true, step: 0 });
            this.$store.dispatch('setUserProps', { selectedDocument: 'cpf', emailConfirmation: null, email: null, document: null, name: null, phone: null });
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      signSteps: 'signSteps'
    }),
  }
};
</script>

<style scoped>
.v-stepper__step{
  padding: 0px 24px !important;
}
.v-stepper__header{
  height: 60px !important;
}
</style>

<style lang="stylus" scoped>
@import '~@/assets/modal/modalSteps.styl';
</style>
